import { take, call, select, fork, cancel, cancelled } from 'redux-saga/effects';
import { fetchBills } from './actions';
import { login } from '../auth/actions';
import { logoutButtonClick } from '../../components/Auth/actions';
import { fetchDevices } from '../devices/actions';
import { changeCurrentDevice } from '../../components/Header/actions';
import { bindAsyncAction } from '../../utils/sagas';
import { apiRequest } from '../../utils/api';

const worker = bindAsyncAction(fetchBills, function* load(params) {
  return yield call(apiRequest, params);
});

export default function* billsSaga() {
  while (true) {
    yield take(login.done.type);
    yield take(fetchDevices.done.type);

    const billSaga = yield fork(getBillsSaga);

    yield take(logoutButtonClick.type);
    yield cancel(billSaga);
  }
}

function* getBillsSaga() {
  const devices = yield select(state => state.devices.devices);
  yield fork(fetchBillsSaga);
  if (devices.length) {
    while (true) {
      yield take(changeCurrentDevice.type);
      yield fork(fetchBillsSaga);
    }
  }
}

function* fetchBillsSaga() {
  const currentDevice = yield select(state => state.devices.currentDevice.id);
  try {
    yield call(worker, {
      url: '/api/v3/Orders/New',
      params: {
        DeviceId: currentDevice,
      },
    });
  } catch (e) {
    if (yield cancelled()) {
    } else {
      throw new Error(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/bills/index.js